<ef-reporting
    #reportingPresenter
    [process]="process$ | async"
    [reports]="reports$ | async"
    [scheduledDates]="scheduledDates$ | async"
    [directReports]="directReports$ | async"
    [costCenters]="costCenters$ | async"
    [contracts]="contracts$ | async"
    [userEntryStartDate]="(userInfo$ | async).CurrentPayPeriodStart"
    [userEntryEndDate]="(userInfo$ | async).CurrentPayPeriodEnd"
    [maxReports]="maxReports$ | async"
    (RunReports)="onRunReports($event)"
    (FavoriteToggle)="onFavoriteToggle($event)"
></ef-reporting>
